import { Grid, LinearProgress } from '@mui/material'
import { DataGrid, GridColDef } from '@mui/x-data-grid'
import clsx from 'clsx'
import React from 'react'
import { UserGroupRow } from 'src/modules/admin/group-manager/gm_scopes'
import { ProfileScope } from '../../gp_scopes'
import ProfileCard from './profile-card'

import CheckIcon from '@mui/icons-material/Check'
import ClearIcon from '@mui/icons-material/Clear'

const rowsPerPageOptions = [10, 25, 50, 75, 100, 500]

export type GroupUsersTableProps = {
    className?: string
    style?: React.CSSProperties
    key?: string
    scope: ProfileScope
}

function GroupUsersTable({ scope, className, style }: GroupUsersTableProps) {
    const users = scope.profile?.users || ([] as UserGroupRow[])
    const columns = static_build_history_columns()

    return (
        <ProfileCard caption="Usuários do grupo" className={clsx(className)} style={style}>
            <Grid container spacing={2}>
                <Grid size={{ sm: 12 }} sx={{ height: 594 }}>
                    <DataGrid
                        rows={users}
                        columns={columns}
                        getRowId={static_getRowId}
                        disableColumnSelector
                        pageSizeOptions={rowsPerPageOptions}
                        initialState={{
                            pagination: {
                                paginationModel: {
                                    pageSize: 10
                                }
                            }
                        }}
                    />
                    {scope.waiting && <LinearProgress color="secondary" />}
                </Grid>
            </Grid>
        </ProfileCard>
    )
}
export default GroupUsersTable

function static_build_history_columns(): GridColDef[] {
    return [
        {
            field: 'name',
            headerName: 'Usuário',
            width: 300
        },
        {
            field: 'full_name',
            headerName: 'Nome Completo',
            width: 300
        },
        {
            field: 'active',
            headerName: 'Ativo',
            align: 'center',
            headerAlign: 'center',
            width: 80,
            renderCell(params) {
                return (params.value && <CheckIcon color="success" />) || <ClearIcon color="warning" />
            }
        }
    ]
}

function static_getRowId(row: UserGroupRow) {
    return row.id + ''
}
